import { handleShowInDirectory } from '../api/api';

export const showInDirectory = handleShowInDirectory;
